import { useApiConfigStore } from "@store/api_config";
import axios from "axios";

const publicApi = axios.create();
publicApi.interceptors.request.use((config) => {
  config.baseURL = useApiConfigStore.getState().getApiUrl();
  return config;
});

export const sessionsApi = {
  create: async (orgId: string): Promise<{ session_id: string }> => {
    const { data } = await publicApi.post(`/public/org/${orgId}/booking-sessions`, { org_id: orgId, step: 0 });
    return data;
  },

  update: async (
    orgId: string,
    sessionId: string,
    payload: { step?: number; status?: string; booking_id?: string; plate?: string; service?: string }
  ): Promise<void> => {
    await publicApi.patch(`/public/org/${orgId}/booking-sessions/${sessionId}`, payload);
  },

  getHistory: async (orgId: string, days = 30): Promise<
    { date: string; started: number; completed: number; abandoned: number }[]
  > => {
    const { data } = await publicApi.get(`/public/org/${orgId}/booking-sessions/history`, { params: { days } });
    return data;
  },

  getStats: async (orgId: string): Promise<{
    total: number;
    completed: number;
    abandoned: number;
    in_progress: number;
    conversion_rate: number;
    avg_abandon_step: number;
  }> => {
    const { data } = await publicApi.get(`/public/org/${orgId}/booking-sessions/stats`);
    return data;
  },
};
